// export const ALLOWED_PLANS = [
//   { id: 'plan_RPlHodoFRw6p0r', value: 60, setValue: 50 },
//   { id: 'plan_RPlMiyuNj9wHYo', value: 120, setValue: 100 },
//   { id: 'plan_RPlOcBQNdSmxJa', value: 180, setValue: 150 },
//   { id: 'plan_RPlMoV9sei79cV', value: 240, setValue: 200 },
//   { id: 'plan_RPlMuoxhryra6q', value: 300, setValue: 250 },
//   { id: 'plan_RPlN5azwVVZsmh', value: 360, setValue: 300 },
//   { id: 'plan_RPlNDZLNeUBCFo', value: 480, setValue: 400 },
//   { id: 'plan_RPlNKtDrPp9RZG', value: 600, setValue: 500 },
//   { id: 'plan_RPlNRyQPzjUMD2', value: 900, setValue: 750 },
//   { id: 'plan_RPlNaPBnbr7iOv', value: 1200, setValue: 1000 },
// ]; 
// Old without gst dev	
// export const ALLOWED_PLANS = [
//   { id: "plan_QFmk3S91JksTqs", value: 50 },
//   { id: "plan_QFmkbItPFnBplP", value: 75 },
//   { id: "plan_QFml66feYC8g8a", value: 100 },
//   { id: "plan_QFmm1sS56YnXQF", value: 125 },
//   { id: "plan_QFmhTJbnrntDFe", value: 150 },
// ];

// Old without gst
// export const ALLOWED_PLAN_LIVE = [
//   { id: "plan_QExSe8NbI0fuvv", value: 50 },
//   { id: "plan_QExf6uDP0f133p", value: 75 },
//   { id: "plan_QExfflFOB4x2qO", value: 100 },
//   { id: "plan_QExgNu0hbgnZ6S", value: 125 },
//   { id: "plan_QExgt1VRzEDWlt", value: 150 },
//   { id: "plan_QWT86NcgluFQKo", value: 250 },
//   { id: "plan_QWTHlwPQrgJRZY", value: 500 },
//   { id: "plan_QWTM5LfUPe4HuM", value: 1000 }
// ];

// gst pricing live lans
export const ALLOWED_PLANS = [
  { id: 'plan_Rtrx3YDx1H5lq1', value: 60, setValue: 50 },
  { id: 'plan_RtrxYG6ktannWL', value: 120, setValue: 100 },
  { id: 'plan_Rtry73f0rNlTo1', value: 180, setValue: 150 },
  { id: 'plan_RtryMHMzFfd2V2', value: 240, setValue: 200 },
  { id: 'plan_RtryYBNNTDw4HS', value: 300, setValue: 250 },
  { id: 'plan_RtrylBTWigkfRM', value: 360, setValue: 300 },
  { id: 'plan_RtryvWMe3rewOf', value: 480, setValue: 400 },
  { id: 'plan_RtrzF8BddfRc0V', value: 600, setValue: 500 },
];

export const ALLOWED_PLAN_VALUES = ALLOWED_PLANS.map((plan) => plan.value); 

export const ALLOWED_PLAN_SET_VALUES = ALLOWED_PLANS.map((plan) => plan.setValue);

export const snapToAllowedSetPrice = (value: number) => {
  return ALLOWED_PLAN_SET_VALUES.reduce((prev, curr) =>
    Math.abs(curr - value) < Math.abs(prev - value) ? curr : prev
  );
};

/**
 * Maps a user-facing price (setValue) back to the actual backend price (value).
 * @param setPrice The snapped 'setValue' from the slider.
 * @returns The corresponding 'value' or the setPrice if no match is found.
 */
export const mapSetPriceToActualPrice = (setPrice: number): number => {
  const plan = ALLOWED_PLANS.find(p => p.setValue === setPrice);
  return plan ? plan.value : setPrice; // Return actual 'value'
};

/**
 * Gets the user-facing price (setValue) from the stored actual price (value).
 * This is used to correctly position the slider on load.
 * @param actualPrice The price stored in the Redux state (monthlyPrice).
 * @returns The corresponding 'setValue'.
 */
export const getSetPriceFromActualPrice = (actualPrice: number): number => {
  const plan = ALLOWED_PLANS.find(p => p.value === actualPrice);
  return plan ? plan.setValue : actualPrice; 
};